var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.offices),function(office,index){return _c('office',{key:index,class:{ 'mt-4': index > 0, 'border-b': _vm.offices.length > 1 },attrs:{"office":office,"isExpanded":_vm.offices.length == 1}})}))}
var staticRenderFns = []

export { render, staticRenderFns }